import {
  SEND_MAIL,
  LIST_RATERS,
  RATERS_SUCCESS,
  RATERS_ERROR,

} from "./actionTypes"

// edit RATERS
export const editRaters = (data, id, callback) => {
  return {
    type: SEND_MAIL,
    payload: { data, id, callback },
  }
}

// list RATERS
export const listRaters = (data, callback) => {
  return {
    type: LIST_RATERS,
    payload: { data, callback },
  }
}


export const ratersSuccess = message => {
  return {
    type: RATERS_SUCCESS,
    payload: message,
  }
}

export const ratersError = message => {
  return {
    type: RATERS_ERROR,
    payload: message,
  }
}
